module.exports = {
      id: "comm-children-usage",
      viewBox: "0 0 237.872 42.449",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#comm-children",
      toString: function () {
        return this.url;
      }
    }